import { useEffect, useState } from "react";
import { Footprints, Loader2, Check, Bone } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PetAvatar } from "@/components/PetAvatar";

export function PetVisits({ myPet }) {
  const { refreshUser } = useAuth();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = () => api.get("/pet/friends").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d) return null;
  const treat = async (f) => {
    setBusy(`t-${f.owner.user_id}`);
    try { await api.post(`/pet/visit/${f.owner.user_id}/treat`); toast.success(`Leckerli für ${f.name} dagelassen – +${d.treat_xp} Wachstum 🦴`); refreshUser?.(); await load(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(null); }
  };
  const visit = async (f) => {
    setBusy(f.owner.user_id);
    try { await api.post(`/pet/visit/${f.owner.user_id}`); toast.success(`${myPet} hat ${f.name} besucht – +${d.points} Punkte für euch beide 🐾`); refreshUser?.(); await load(); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(null); }
  };
  return (
    <div className="bg-white rounded-3xl border border-pink-100 p-5 sm:p-6 space-y-4" data-testid="pet-visits">
      <div>
        <h2 className="font-display text-xl font-extrabold flex items-center gap-2"><Footprints className="w-5 h-5 text-rose-500" /> Freunde besuchen</h2>
        <p className="text-sm text-slate-500">Bis zu {d.per_day} Besuche am Tag, jeder bringt dir und deinem Freund {d.points} Punkte. Nach dem Besuch kannst du für {d.treat_price} Punkte ein Leckerli dalassen (+{d.treat_xp} Wachstum). Heute noch <b data-testid="pet-visits-left">{d.left}</b> frei{d.received_today ? ` · ${d.received_today}× Besuch bekommen` : ""}.</p>
      </div>
      {d.friends.length === 0 ? <p className="text-sm text-slate-400" data-testid="pet-visits-empty">Noch keiner deiner Freunde hat ein Haustier – erzähl ihnen davon!</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {d.friends.map((f) => (
            <div key={f.owner.user_id} className="rounded-2xl border border-pink-100 p-3 text-center" data-testid={`pet-visit-card-${f.owner.user_id}`}>
              <PetAvatar kind={f.kind} name={f.name} equipped={f.equipped} className="w-20 h-20 mx-auto" />
              <p className="font-bold text-sm mt-1.5 truncate">{f.name}</p>
              <p className="text-[11px] text-slate-400 truncate">von {f.owner.name}</p>
              <button onClick={() => visit(f)} disabled={f.visited || !d.left || busy === f.owner.user_id} data-testid={`pet-visit-${f.owner.user_id}`}
                className={`mt-2 w-full h-9 rounded-full text-xs font-bold inline-flex items-center justify-center gap-1 disabled:opacity-60 active:scale-95 transition-transform ${f.visited ? "bg-rose-50 text-rose-600" : "pink-gradient text-white"}`}>
                {busy === f.owner.user_id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : f.visited ? <><Check className="w-3.5 h-3.5" /> Besucht</> : "Besuchen"}
              </button>
              {f.visited && (
                <button onClick={() => treat(f)} disabled={f.treated || busy === `t-${f.owner.user_id}`} data-testid={`pet-treat-${f.owner.user_id}`}
                  className="mt-1.5 w-full h-9 rounded-full text-xs font-bold inline-flex items-center justify-center gap-1 border border-amber-300 text-amber-700 bg-amber-50 disabled:opacity-60 active:scale-95 transition-transform">
                  {busy === `t-${f.owner.user_id}` ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Bone className="w-3.5 h-3.5" />} {f.treated ? "Leckerli da" : `Leckerli (${d.treat_price} P.)`}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
